
import {computed, defineComponent, inject, PropType} from "vue";
import {INode} from "@/interfaces/evidence-map";
import NodeList from "@/components/NodeList.vue";
import TopicViewer from "@/components/TopicViewer.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "NodeViewer",
  components: {TopicViewer, NodeList},
  props: {
    node: Object as PropType<INode>
  },
  setup(props) {
    const mapStore = useMapStore()
    const hideViewer = computed(() => mapStore.getNodesByParent(props.node.id).length == 1)
    return {
      hideViewer,
      mapStore
    }
  }
})
